import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";

function ConfirmationModal({ isOpen, toggle, title, message, onConfirm, confirmationText, confirmColor = 'danger', zIndex }) {
  const { t } = useTranslation();
  const btnText = confirmationText || t('common.delete');

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      zIndex={zIndex}
    >
      <ModalHeader toggle={toggle}>{title}</ModalHeader>

      <ModalBody>
        <p className="mb-0 fs-5">{message}</p>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-secondary btn-sm" onClick={toggle}>{t('common.cancel')}</button>
        <button className={`btn btn-${confirmColor} btn-sm`} onClick={() => {
          onConfirm();
          toggle();
        }}>{btnText}</button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmationModal;
